import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=8c58b630&scoped=true"
import script from "./AppLink.vue?vue&type=script&lang=js"
export * from "./AppLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c58b630",
  null
  
)

export default component.exports